/** @format */

export * from './recommendation-card.module';
